module.exports = __webpack_public_path__ + "static/img/ZA@3x.94bcbec3.jpg";